import React from 'react';

const NodeLine = () => {
  return (
    <div className="node-line">
    </div>
  );
}

export default NodeLine;
